import { errorHandler, loadersSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { takeLatest, put, call, select } from 'typed-redux-saga'
import { RequestParams, ResponseCatalog, ProductRecommendationModel } from 'Models'
import { productSelectors, productApi, productsNS, productsSlice } from 'Pages/orders_design'
import { Callback } from 'Src/types/utilTypes'
import { ProductModel } from 'Pages/orders'

function* getAllProducts(requestParams?: RequestParams, clear?: boolean, callback?: Callback) {
	yield* put(loadersSlice.actions.showGlobalLoader())
	let params = yield* select(productSelectors.getParams)
	let oldItems = new ResponseCatalog<ProductModel>()
	if (!clear && requestParams?.page !== 1) {
		oldItems = yield* select(productSelectors.getItems)
	} else if (clear) {
		const { page, per_page = 30, query = undefined, ...rest } = { ...params, page: 1 }
		params = new RequestParams(page, per_page, query, rest)
		yield* put(productsSlice.actions.clearAll())
		yield* put(productsSlice.actions.setRequestParams(params))
	}
	const res = yield* call(productApi.getItems, requestParams || params)
	const products = new ResponseCatalog<ProductModel>(res)
	const newOrders = res.entries.map((product): ProductModel => Deserialize(product, ProductModel))
	products.entries = [...oldItems.entries, ...newOrders]
	yield* put(productsSlice.actions.setAll(products))
	yield* put(loadersSlice.actions.hideGlobalLoader())
	callback?.()
}

function* getProductsSaga(action: productsNS.getAll) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { params, clear, callback } = action.payload
		yield* call(getAllProducts, params, clear, callback)
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getRecommendationSaga(action: productsNS.getRecommendations) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(productApi.getRecommendation, action.payload)
		const recommendations = new ResponseCatalog<ProductRecommendationModel>(res)
		recommendations.entries = res.entries.map(
			(recommendation): ProductRecommendationModel =>
				Deserialize(recommendation, ProductRecommendationModel)
		)
		yield* put(productsSlice.actions.setRecommendations(recommendations))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* getBusinessappsSaga(action: productsNS.getBusinessapps) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(productApi.getBusinessapps, action.payload)
		yield* put(productsSlice.actions.setBusinessapps(res))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* productsSaga() {
	yield* takeLatest(productsSlice.actions.getAll.type, getProductsSaga)
	yield* takeLatest(productsSlice.actions.getRecommendations.type, getRecommendationSaga)
	yield* takeLatest(productsSlice.actions.getBusinessapps.type, getBusinessappsSaga)
}
